import { PopoverInstance, PopoverWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { UserDefinedPoolModel } from '../types/PoolModel';

export type PoolNamePopoverProps = Readonly<{
  pool: UserDefinedPoolModel;
}>;

export function PoolNamePopover(props: PoolNamePopoverProps) {
  const popoverInstance = React.useRef<PopoverInstance>(null);

  return (
    <PopoverWidget
      testId='pool-name-popover'
      aria-describedby='popoverDescription'
      placement='right'
      popoverContent={<form>
        <p id='popoverDescription'>{Messages.dataConnectSiteSettingsPoolId()} {props.pool.poolId}</p>
      </form>}
      ref={popoverInstance}
      title={Messages.dataConnectSiteSettingsPoolId()}
      showTitleBar={false}
      triggerElement={
        <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} style={{paddingLeft:0}} data-tb-test-id={'pool-name-cell'}>
          {props.pool.displayName}
        </span>
      }
    />
  );
}
